import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  IconButton,
  Box,
} from "@chakra-ui/react";
import { InfoIcon } from "lucide-react";

export default function InfoPopover(props : { content: string, marginBottom?: string, margin?: string }) {
  return (
    <Box marginBottom={props.marginBottom} margin={props.margin}>
    <Popover placement="top" trigger="click">
      <PopoverTrigger>
        <IconButton
          icon={<InfoIcon/>}
          aria-label="Mer info"
          size="sm"
          variant="ghost"
        />
      </PopoverTrigger>

      <PopoverContent w="200px">
        <PopoverArrow />
        <PopoverBody fontSize="sm">
            {props.content}
        </PopoverBody>
      </PopoverContent>
    </Popover>
        </Box>
  );
}